import styled from 'styled-components'
import { FONT_SIZE } from '../../themes'

export const Style = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .wrap-logo {
    text-align: center;
  }
  .wrap-text {
    text-align: center;
    > h1 {
      font-family: LibreBaskervilleBold;
      font-size: ${FONT_SIZE.XL};
      margin: 60px 0 0;
    }
    > span {
      font-family: NunitoSansRegular;
      font-size: ${FONT_SIZE.MD};
    }
  }
  .marketplace-app-store {
    margin-top: 40px;
  }
  .marketplace-android {
    margin-top: 30px;
  }
`
